@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  border-left: 4px solid var(--surface-primary);
  @include border-radius-r2;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  background: var(--surface-soft);
  border: 1px solid var(--border-soft);
  @include border-radius-r2;
}

.title {
  @include typography-v2-ui-sm;
  color: var(--text-soft);
}

.text {
  @include typography-v2-body-base;
  color: var(--text-default);
}
